import Intro from 'components/logistics/stats/intro';
import React from 'react';
import { OrderStat } from '.';

type Props = {
  loading: boolean;
  data: OrderStat;
};

const LogisticsStatsPageOne = ({ loading, data }: Props) => {
  const total_orders =
    parseInt(data?.success_order_count ?? 0) + parseInt(data?.failed_order_count ?? 0);
  const completed_orders = data?.success_order_count ? parseInt(data?.success_order_count) : 0;
  return (
    <Intro
      total_orders={total_orders}
      completed_orders={completed_orders}
      avg_order_duration={data?.average_delivery_time ?? 0}
      loading={loading}
    />
  );
};
export default LogisticsStatsPageOne;
